import React, { Fragment } from 'react';
import { useTranslation } from "react-i18next";
import doctorado from '../../assets/images/doctorado-ingenieria-uniandes.jpg';
import banner from '../../assets/images/campus-ml-condiciones.jpg';

const University = () =>{

    const { t } = useTranslation();

    return(
        <Fragment>
            <section Style="background-color: #083F5B" className="text-white">
                <div className="max-w-7xl mx-auto flex flex-wrap justify-center lg:justify-between pt-3">
                    <div className="w-full lg:w-1/2">
                        <h1 className="text-white font-bold text-4xl px-4 text-center lg:px-0 lg:text-left">{t("general.title")}</h1><br /><br />
                        <p className="font-sans text-base text-justify px-4 lg:px-0 lg:py-4">{t("general.description")}</p>
                        <p className="text-justify px-4 pt-2 text-sm lg:px-0 lg:pt-0 "><strong>Registro Calificado: </strong>Resolución 4325 del 14 de marzo de 2018 por 7 años - <strong>SNIES: </strong> 16071</p>
                    </div>
                    <div className="w-auto px-4 py-2 md:p-3 lg:w-1/2">
                        <img
                            className="object-cover overflow-hidden rounded-md w-auto border border-white"
                            src={doctorado}
                            alt="Banner Universidad de los Andes"
                        />    
                    </div>
                </div>
            </section>
            <section Style="background-color: #083F5B" className="text-white">
                <div className="max-w-7xl mx-auto flex flex-wrap justify-center items-center lg:py-2">
                    <div className="w-full p-2 md:w-auto md:border-r-2 md:border-white">
                        <span><strong>{t("general.features.duration.title")} </strong>{t("general.features.duration.description")}</span>
                    </div>
                    <div className="w-full p-2 md:w-auto md:border-r-2 md:border-white">
                        <span><strong>{t("general.features.delivery_mode.title")} </strong>{t("general.features.delivery_mode.description")}</span>
                    </div>
                    <div className="w-full p-2 md:w-auto md:border-r-2 md:border-white">
                        <span><strong>{t("general.features.credits.title")} </strong>{t("general.features.credits.description")}</span>
                    </div>
                    <div className="w-full p-2 md:w-auto">
                        <span><strong>{t("general.features.commitment.title")} </strong>{t("general.features.commitment.description")}</span>
                    </div>
                </div>
            </section>
            <section className="max-w-7xl mx-auto">
                <div className="py-3 px-4 lg:px-0">   
                    <h2 className="text-3xl font-bold pt-4 text-left lg:pt-0">{t("homologate.label")}</h2>
                    <div className="pt-3 lg:flex lg:flex-row lg:justify-between lg:items-center">
                        <img
                            className="float-left w-48 rounded-md my-0 mr-2 lg:w-96 lg:float-none"
                            src={banner}
                            alt="Banner Universidad de los Andes"
                        />
                        <p className="text-justify lg:pl-2">{t("homologate.description")}</p>
                    </div>
                </div>
            </section>
        </Fragment>
    )
}

export default University;